import { Group, IconButton, iconSizes, Stack, Text } from '@common/ui'
import { IconPlus } from '@common/ui/icons'
import { useState } from 'react'
import { com } from '@eidu/web'
import SemanticLinkField from './SemanticLinkField'
import SemanticLinkDisplay from '../data/SemanticLinkDisplay'
import { useDeleteSemanticLink } from '../../io/useSemanticLinks'
import SemanticLinkConfig from '../../types/SemanticLinkConfig'
import EntityType = com.eidu.entity.type.EntityType
import SemanticLink = com.eidu.entity.analytics.SemanticLink
import SemanticLinkId = com.eidu.entity.analytics.SemanticLinkId

type SemanticLinksItemProps = {
  entityType: EntityType
  entityTypes: readonly EntityType[]
  semanticLinks: readonly SemanticLink[]
  semanticLinkConfig: SemanticLinkConfig
}

const SemanticLinksItem = ({ entityType, entityTypes, semanticLinks, semanticLinkConfig }: SemanticLinksItemProps) => {
  const [creating, setCreating] = useState(false)
  const { delete: deleteLink } = useDeleteSemanticLink()

  const linksForKey = semanticLinks.filter(({ key }) => key.equals(semanticLinkConfig.key))
  const canAddLink = linksForKey.length === 0 || semanticLinkConfig.duplicatesAllowed

  const handleSave = () => {
    setCreating(false)
  }

  const handleDelete = async (semanticLinkId: SemanticLinkId) => {
    try {
      await deleteLink(semanticLinkId)
    } catch (error) {
      console.error('Error deleting semantic link', error)
    }
  }

  return (
    <Stack key={semanticLinkConfig.key.toString()} gap="xs">
      <Stack gap="xs">
        <Group gap="xs" align="center">
          <Text>{semanticLinkConfig.title}</Text>
          {canAddLink && !creating && (
            <IconButton onClick={() => setCreating(true)} size="sm" aria-label="add semantic link">
              <IconPlus size={iconSizes.sm} stroke={1.5} />
            </IconButton>
          )}
        </Group>

        {creating && (
          <SemanticLinkField
            entityType={entityType.id}
            entityTypes={entityTypes}
            semanticLinkConfig={semanticLinkConfig}
            onSave={handleSave}
            onCancel={() => setCreating(false)}
          />
        )}

        {!(linksForKey.length === 0 && creating) && (
          <SemanticLinkDisplay
            entityTypeId={entityType.id}
            entityTypes={entityTypes}
            fieldType={semanticLinkConfig.fieldType}
            semanticLinks={linksForKey}
            onDelete={handleDelete}
          />
        )}
      </Stack>
    </Stack>
  )
}

export default SemanticLinksItem
